import { render, staticRenderFns } from "./ProAppIntelligenceMessage.vue?vue&type=template&id=44928580&scoped=true&"
import script from "./ProAppIntelligenceMessage.vue?vue&type=script&lang=js&"
export * from "./ProAppIntelligenceMessage.vue?vue&type=script&lang=js&"
import style0 from "./ProAppIntelligenceMessage.vue?vue&type=style&index=0&id=44928580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44928580",
  null
  
)

export default component.exports